
import { createSlice } from '@reduxjs/toolkit'

export const sideBarReducer = createSlice({
  name: 'sidebar',
  initialState:{
    value:false
  },
  reducers: {
    collapse: (state) => {
      state.value = !state.value
    },
   
  },
})

export const { collapse } = sideBarReducer.actions

export default sideBarReducer.reducer